
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarStandbyIec as ObiRadarStandbyIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-standby-iec.js';
 
 
 

 
 export const ObiRadarStandbyIec = createComponent({
   react: React,
   tagName: 'obi-radar-standby-iec',
   elementClass: ObiRadarStandbyIecElement,
   events: {
     
   }
  });
 
 